import React from 'react';
import { func, string } from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import useStyles from 'hooks/useStyles';

import Button from 'components/Button';
import { ChevronIcon } from 'components/Icon';

import styles from './SeeMoreRow.scss';

export default function SeeMoreRow({ onClick, className, hintIcon }) {
  useStyles(styles);
  const { t } = useTranslation('live');

  return (
    <div className={cx(styles.root, className)}>
      <Button onClick={onClick} ghost type="primary" className={styles.button}>
        {t('live:seeMore_cta')}
        {hintIcon ? (
          React.createElement(hintIcon, { className: styles.hintIcon })
        ) : (
          <ChevronIcon className={styles.chevronIcon} />
        )}
      </Button>
    </div>
  );
}

SeeMoreRow.propTypes = {
  onClick: func,
  className: string,
  hintIcon: func,
};

SeeMoreRow.defaultProps = {
  className: '',
  onClick: () => {},
  hintIcon: undefined,
};
